import { useStoreState } from "../store";

export default function ErrorBanner() {
  const { error } = useStoreState();
  return <div className="text-lg text-center text-red font-bold error-banner">{error}</div>;
}
